import { Box, Link } from '@material-ui/core';
import React from 'react';

import { InfoCellProps } from './InfoCell.type';
import './InfoCell.scss';
import { useConnectAuth } from '../../../hooks/useConnectAuth';

const InfoCell: React.FC<InfoCellProps> = ({ description, icon, links = [], title }) => {
  const { startConnectLogin } = useConnectAuth();

  return (
    <Box className="info-cell">
      <Box className="info-cell__icon" component="span">
        {icon}
      </Box>

      <Box className="info-cell__title">{title}</Box>

      {description && <Box className="info-cell__description">{description}</Box>}

      <Box className="info-cell__links">
        {links.map(link => (
          <Link
            key={link.text}
            data-testid={`info-cell-link-${link.testid}`}
            {...(link.url && { href: link.url })}
            {...(link.action && link.action === 'connectlogin' && { onClick: startConnectLogin })}
            className="info-cell__link"
            rel="noopener noreferrer"
            target={link?.target ?? ''}
          >
            {link.text}
          </Link>
        ))}
      </Box>
    </Box>
  );
};

export default InfoCell;
